import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/digithia-logo.png'


const _hoisted_1 = { class: "activate-account" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  slot: "logo",
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_3 = {
  slot: "title",
  class: "center title-2"
}
const _hoisted_4 = { slot: "form" }
const _hoisted_5 = { class: "activate-account-form" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "password-hack" }
const _hoisted_8 = { class: "submit" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("dig-ui-login-card", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("dig-ui-title", _hoisted_3, _toDisplayString(_ctx.$t('choosePasswordActivateAccount')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("dig-input-password", {
          value: _ctx.password,
          onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.update($event.target.value))),
          required: "",
          id: "password",
          name: "password",
          ref: "passwordEl"
        }, _toDisplayString(_ctx.$t('User.password')), 41, _hoisted_6),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.passwordHackedIn), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("dig-ui-standard-button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activateAccount(_ctx.password))),
          disabled: _ctx.loading
        }, _toDisplayString(_ctx.$t('activateAccount')), 9, _hoisted_9)
      ])
    ])
  ]))
}